:host([light]) {
    & .harddrive_d,
    & .harddrive_e,
    & .harddrive_f,
    & .harddrive_g {
        fill-rule: evenodd;
    }
    & .harddrive_d,
    & .harddrive_h {
        fill: #fff;
    }
    & .harddrive_e {
        fill: url(#harddrive_c);
    }
    & .harddrive_h {
        stroke-width: 5px;
    }
    & .harddrive_h,
    & .harddrive_i {
        stroke: #1a4e85;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .harddrive_f {
        fill: url(#harddrive_b);
    }
    & .harddrive_i {
        fill: none;
        stroke-width: 10px;
    }
    & .harddrive_j {
        fill: #1a4e85;
    }
    & .harddrive_g {
        fill: #bbdefb;
    }
}
:host([dark]) {
    & .harddrive_d,
    & .harddrive_e {
        fill: #09264a;
    }
    & .harddrive_e,
    & .harddrive_f,
    & .harddrive_g,
    & .harddrive_h {
        fill-rule: evenodd;
    }
    & .harddrive_i {
        fill: none;
        stroke: #fff;
        stroke-width: 10px;
    }
    & .harddrive_i,
    & .harddrive_j {
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .harddrive_f {
        fill: url(#harddrive_c);
    }
    & .harddrive_g {
        fill: url(#harddrive_b);
    }
    & .harddrive_h,
    & .harddrive_j {
        fill: #ced4db;
    }
    & .harddrive_j {
        stroke: #09264a;
        stroke-width: 5px;
    }
}
